import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const faireVersementEndpoint = API_ROUTE.FAIRE_VERSEMENT;

interface FaireVersementData {
  idSouscription: number;
  typeVersement: string;
  montantVersement: number;
  objectifPrincipal: string;
  origineCapitaux: string;
  autreOrigineFonds: string;
  dateOrigineFonds: string;
  placementDesFonds: string;
  ibanSelected: string;
  per: boolean;
  deductionFiscale: boolean;
}

export const getFaireVersement = async (faireVersement: FaireVersementData) => {
  const versementData = JSON.parse(sessionStorage.parcoursVersementData);
  const response = await axios.post(
    `${apiBaseUrl}${faireVersementEndpoint}`,
    {
      idSouscription: faireVersement.idSouscription,
      typeVersement: faireVersement.typeVersement,
      montantVersement: faireVersement.montantVersement,
      objectifPrincipal: faireVersement.objectifPrincipal,
      origineCapitaux: faireVersement.origineCapitaux,
      autreOrigineFonds: faireVersement.autreOrigineFonds,
      placementDesFonds: faireVersement.placementDesFonds,
      dateOrigineFonds: faireVersement.dateOrigineFonds,
      per: faireVersement.per,
      ibanSelect: faireVersement.ibanSelected,
      deductionFiscale: faireVersement.deductionFiscale,
    },
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error('Erreur lors de la recuperation des justificatifs');
  }
  const data = await response.data;
  return data;
};
